module.exports = __webpack_public_path__ + "img/logo.4b36b913.png";